import _ from "lodash";
import BorderBox from "../../../../components/borderbox";
import h from "../../../../core/createElement";
import Input from "../../../../components/input";
import { input_params_by_class } from "../../../../utils";

export default function ParametersBox({ parameters, onChangeObject, shared = {}, name = "param_box" }) {
    const
        parameters_inputs = [],
        parameters_object = {},
        inner_shared = {},
        default_parameters = {};

    const on_change_input_value = () => onChangeObject && onChangeObject(parameters_object);

    shared[name] = {
        patch_values_object: (object) => {
            for (let i in parameters) {
                if (inner_shared.hasOwnProperty(i) && object[i]) inner_shared[i].value = object[i];
                else inner_shared[i].value = null;
            };
            return parameters_object;
        },
        get_object: () => parameters_object,
        get_default: () => default_parameters
    };

    for (let i in parameters) {
        default_parameters[i] = parameters_object[i] = null;

        parameters_inputs.push(
            <Input
                shared={inner_shared}
                title={i}
                name={i}
                bindObject={parameters_object}
                placeholder={parameters[i]}
                transformValue={(value, default_transform) => value == "" ? null : default_transform()}
                {...input_params_by_class(parameters[i])}
                onKeyup={on_change_input_value}
                onChange={on_change_input_value}
            />
        );
    };

    return (
        <BorderBox containerClass="flex-1" title="Parâmetros" contentClass="flex-column">
            {_.size(parameters) > 0 ? parameters_inputs : <span class="empty">Nenhum Parâmetro Informado</span>}
        </BorderBox>
    );
};